export default "__VITE_ASSET__B$Rnc0oB__"